import React from "react";
import './styles.css'
import ButtonCustom from "../../../../../../../../Components/ButtonCustom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowRight, faDownload, faRotate } from "@fortawesome/free-solid-svg-icons";
import { Box } from "../../../../../../../../Components/CustomUi/box";

interface Props {
handleDownloadResultado: Function
handleReprocessarOs: Function
}

export const DownloadReprocessarOS:React.FC<Props> = ({
  handleDownloadResultado,
  handleReprocessarOs
}) => {
  return (
    <Box >
      <ButtonCustom onClick={handleDownloadResultado} icon={<FontAwesomeIcon icon={faDownload} />} >Baixar análise</ButtonCustom>
      <ButtonCustom danger type="secondary" onClick={handleReprocessarOs} icon={<FontAwesomeIcon icon={faRotate}/>}>Reprocessar OS</ButtonCustom>

    </Box>
  )
}